import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { WdxBadgeModule } from '@wdx/shared/components/wdx-badge';
import {
    EnumTranslationTypes,
    TranslateTokenisedStringPipe,
} from '@wdx/shared/utils';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'wdx-ag-grid-lifecycle-cell-renderer',

    imports: [
        CommonModule,
        RouterModule,
        WdxBadgeModule,
        TranslateTokenisedStringPipe,
    ],
    template:
        '<div [ngClass]="classes">{{ label | translateTokenisedString:undefined:EnumTranslationTypes.LifecycleStage }}</div>',
})
export class LifecycleRendererComponent implements ICellRendererAngularComp {
    public label?: string;
    public classes = 'badge';
    public EnumTranslationTypes = EnumTranslationTypes;

    public agInit(params: ICellRendererParams<any, string>): void {
        if (params?.value) {
            this.label = params.value;
            this.setClasses(this.label);
        }
    }

    public refresh(params: ICellRendererParams<any, string>): boolean {
        if (params?.value) {
            this.label = params.value;
            this.setClasses(this.label);
        }
        return true;
    }

    private setClasses(label?: string) {
        this.classes = label
            ? `badge lifecycle-stage-${label.toLowerCase()}`
            : 'badge';
    }
}
